import React from 'react'
import { T, Label, Hr } from './SharedLayout'
import InlineAudioPlayer from './InlineAudioPlayer'

/**
 * PerShotAudioSection
 *
 * Displays audio tracks specific to each shot.
 * Used for lip-sync input and precise timing alignment.
 */
const PerShotAudioSection = ({ shots }) => {
  if (!shots || shots.length === 0) return null

  return (
    <section style={{ marginTop: 24 }}>
      <Label>Per-Shot Audio (Review)</Label>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        {shots.map((shotWrapper, idx) => {
          const shotId = Object.keys(shotWrapper)[0]
          const shot = shotWrapper[shotId]
          const hasNar = Boolean(shot.shot_narration_audio_link)
          const hasDia = Boolean(shot.shot_dialogue_audio_link)

          if (!hasNar && !hasDia) return null

          return (
            <div
              key={idx}
              style={{
                padding: '12px 16px',
                background: T.surface,
                borderRadius: 8,
                border: `1px solid ${T.borderLight}`
              }}
            >
              <div
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: T.inkMid,
                  marginBottom: 10,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between'
                }}
              >
                <span>{shot.title || `Shot ${idx + 1}`}</span>
                <span style={{ fontSize: 10, color: T.inkLight }}>
                  {shot.video_duration?.toFixed(2)}s
                </span>
              </div>

              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: '1fr 1fr',
                  gap: 12
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: 9,
                      color: T.inkLight,
                      marginBottom: 4,
                      textTransform: 'uppercase'
                    }}
                  >
                    Narration
                  </div>
                  {hasNar ? (
                    <InlineAudioPlayer
                      src={shot.shot_narration_audio_link}
                      accent={T.blue}
                      compact
                    />
                  ) : (
                    <div style={{ fontSize: 11, color: T.inkLight }}>
                      No audio
                    </div>
                  )}
                </div>
                <div>
                  <div
                    style={{
                      fontSize: 9,
                      color: T.inkLight,
                      marginBottom: 4,
                      textTransform: 'uppercase'
                    }}
                  >
                    Dialogue
                  </div>
                  {hasDia ? (
                    <InlineAudioPlayer
                      src={shot.shot_dialogue_audio_link}
                      accent={T.amber}
                      compact
                    />
                  ) : (
                    <div style={{ fontSize: 11, color: T.inkLight }}>
                      No dialogue
                    </div>
                  )}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default PerShotAudioSection
